import { queryOptions } from '@tanstack/react-query';
import { apiFetch } from '../api-client';

export interface CreateTenantInput {
  companyName: string;
  netsuiteAccountId: string;
  primaryContact: string;
  contactEmail: string;
  planId: string;
  credentialMode: 'platform_managed' | 'byok';
}

export interface OnboardingSession {
  tenantId: string;
  customerId: string;
  signingSecret: string;
  step: number;
}

export interface VerifyCheck {
  id: string;
  label: string;
  detail: string;
  passed: boolean;
}

export interface VerifyResult {
  allPassed: boolean;
  checks: VerifyCheck[];
}

export async function createTenant(
  data: CreateTenantInput,
): Promise<OnboardingSession> {
  const res = await apiFetch('/api/console/customers', {
    method: 'POST',
    body: JSON.stringify({
      name: data.companyName,
      hostAccountId: data.netsuiteAccountId,
      planId: data.planId,
      credentialMode: data.credentialMode,
    }),
  });
  if (!res.ok) throw new Error('Failed to create tenant');
  return res.json();
}

export async function verifyConnection(
  tenantId: string,
): Promise<VerifyResult> {
  const res = await apiFetch(`/api/console/customers/${tenantId}/verify`, {
    method: 'POST',
  });
  if (!res.ok) throw new Error('Verification failed');
  return res.json();
}

export function plansQueryOptions() {
  return queryOptions({
    queryKey: ['plans'],
    queryFn: async () => {
      const res = await apiFetch('/api/console/plans');
      if (!res.ok) throw new Error('Failed to load plans');
      const json = (await res.json()) as {
        plans: {
          id: string;
          name: string;
          includedTokens: number;
          overageRate: string;
          platformAccessFee: string;
          maxUsers: number;
          tenantCount: number;
        }[];
      };
      return json.plans;
    },
  });
}
